import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from 'axios';





export default function SimpleAccordion({title,data}) {
  //console.log(data)

  //const [data,setData] = React.useState()



  var schemaData = []

  for (var i of data) {
      schemaData.push({"@type":"Question","name":i['queOne'],"acceptedAnswer":{"@type":"Answer","text":i['ansOne']}});
  }


 

  
const schema = {"@context":"https://schema.org","@type":"FAQPage","mainEntity":schemaData}


var script;
if (!document.getElementById("schema2020")){
  script = document.createElement('script');
  script.id = 'schema2020'
}else{
  script = document.getElementById("schema2020")

}

script.type = "application/ld+json";
script.innerHTML = JSON.stringify(schema);
document.getElementsByTagName('head')[0].appendChild(script);

  return (
    <div className='dkskds32424'>

      {data.map((sym,index)=>(
<Accordion defaultExpanded>
<AccordionSummary
  expandIcon={<ExpandMoreIcon />}
  aria-controls="panel1a-content"
  id="panel1a-header"
>
  <Typography variant={index == 0 || index == 1 ? index == 0 ? 'h1' : 'h2'  : 'h3'} fontSize={'large'}>{sym.queOne}</Typography>
</AccordionSummary>
<AccordionDetails>
  <Typography>
    {sym.ansOne}
  </Typography>
</AccordionDetails>
</Accordion>
      ))

      }


     
     
    </div>
  );
}